export const closestTo = (value: number, src: number[]) =>
  src.reduce((prev, curr) => {
    return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
  });
